// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Photos__row":"su_a bhp_a bhp_r bhp_j","Photos__img":"su_b bhp_b"};